import { useEffect, useState } from 'react'
import { supabase, type CaseStudy } from '../lib/supabase'

export function usePublishedCaseStudies(limit?: number) {
  const [cases, setCases] = useState<CaseStudy[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let active = true

    async function load() {
      setLoading(true)
      let query = supabase
        .from('case_studies')
        .select('*')
        .not('published_at', 'is', null)
        .lte('published_at', new Date().toISOString())
        .order('published_at', { ascending: false })

      if (limit) query = query.limit(limit)

      const { data, error } = await query

      if (!active) return
      if (error) {
        setError(error.message)
      } else {
        setCases((data ?? []) as CaseStudy[])
      }
      setLoading(false)
    }

    load()
    return () => {
      active = false
    }
  }, [limit])

  return { cases, loading, error }
}

export function useCaseStudyBySlug(slug: string | undefined) {
  const [caseStudy, setCaseStudy] = useState<CaseStudy | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!slug) return
    let active = true

    async function load() {
      setLoading(true)
      const { data, error } = await supabase
        .from('case_studies')
        .select('*')
        .eq('slug', slug)
        .not('published_at', 'is', null)
        .lte('published_at', new Date().toISOString())
        .maybeSingle()

      if (!active) return
      if (error) {
        setError(error.message)
      } else {
        setCaseStudy(data as CaseStudy | null)
      }
      setLoading(false)
    }

    load()
    return () => {
      active = false
    }
  }, [slug])

  return { caseStudy, loading, error }
}
